// Delivery type of a bundle option.
// Any bundle whose name contains "Reader" (Reader's Bundle, Starter Reader's Bundle, ...) is always physical + digital.
export function bundleDeliveryOf(variant) {
    if (variant && /reader/i.test(variant.bundleName || "")) return "Combo";
    return (variant && variant.bundleDelivery) || "Physical";
}
